import React, { useEffect } from "react";

import { clearStore } from "../..";
import { SessionStorage } from "../../util";
import { PageNotFound } from "./PageNotFound";

const SessionExpiredModal = () => {

  useEffect(() => {
    clearStore();
    SessionStorage.clearAll();
  }, [])

  return (<><PageNotFound sessionExpired={true} /></>)
}
export { SessionExpiredModal }